export default "__VITE_ASSET__ea52b892__"